/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import LeadStatusDropdown from 'domain/sales/lead/shared/input/LeadStatusDropdown';
import { DefaultDropdownProps } from 'framework/form';

const LeadStatusFilter = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <DropDownFilter {...props}>
      <LeadStatusDropdown {...props} />
    </DropDownFilter>
  );
};

export default LeadStatusFilter;
